import { useMemo } from 'react';
import { Table } from 'redesign';
import { usePopupProfile } from 'ogp/components/views/planning/hooks';
import { useTranslation } from 'react-i18next';
import { translateWorkerStatus } from 'shared/utils/translate-preferred-worker-status';
import { FlexWorkerRelation } from 'ogp/hooks/queryHooks/flexWorkers/useGetFlexWorkerProfile';
import {
  PreferredWorkerColumnDefinition,
  PreferredWorkerTableOptions,
} from './helpers/preferred-worker-table.types';
import { VisibilityRule } from './preferred-worker.types';
import { useGetPreferredWorkersColumnDefinition } from './helpers/use-get-preferred-workers-column-definition';
import { getPreferredWorkersTableData } from './helpers/get-preferred-workers-table-data';

type Props = {
  visibilityRules: VisibilityRule[];
};

export const PreferredWorkersTable = ({ visibilityRules }: Props) => {
  const { t } = useTranslation('web-common');

  const mappedVisibilityRulesData = visibilityRules.map((rule) => ({
    ...rule,
    workers: rule.workers.map((worker) => ({
      ...worker,
      status: translateWorkerStatus(worker.status, t),
    })),
  }));

  const columns = useGetPreferredWorkersColumnDefinition();
  const tableData = useMemo(
    () => getPreferredWorkersTableData(mappedVisibilityRulesData),
    [mappedVisibilityRulesData]
  );

  const { open: openPopupProfile, Element: PopupProfileElement } = usePopupProfile();

  const onProfileClick = (workerId: string, relation: FlexWorkerRelation) => {
    openPopupProfile(workerId, relation);
  };

  return (
    <>
      {PopupProfileElement}
      <Table<PreferredWorkerColumnDefinition, PreferredWorkerTableOptions>
        stickyHeader={true}
        columns={columns}
        data={tableData}
        onProfileClick={onProfileClick}
      />
    </>
  );
};
